import React, { createContext, useContext, useEffect, useState } from "react";

const SUPPORTED = ["en", "es", "nl", "fr"];

const LanguageContext = createContext({ lang: "en", setLang: () => {} });

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "en";
        // 1. `?lang=xx` in the URL wins (used by hreflang alternates + share links)
        try {
            const q = new URLSearchParams(window.location.search).get("lang");
            if (q && SUPPORTED.includes(q)) return q;
        } catch (_e) { /* noop */ }
        // 2. Previously stored preference
        const stored = window.localStorage.getItem("liap-lang");
        if (SUPPORTED.includes(stored)) return stored;
        // 3. Browser language
        const nav = (window.navigator?.language || "en").slice(0, 2).toLowerCase();
        return SUPPORTED.includes(nav) ? nav : "en";
    });

    const setLang = (next) => {
        const value = SUPPORTED.includes(next) ? next : "en";
        setLangState(value);
        try { window.localStorage.setItem("liap-lang", value); } catch (e) { /* ignore */ }
        document.documentElement.setAttribute("lang", value);
    };

    useEffect(() => {
        document.documentElement.setAttribute("lang", lang);
    }, [lang]);

    return (
        <LanguageContext.Provider value={{ lang, setLang, supported: SUPPORTED }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const LANGS = SUPPORTED;
